// apps/client/src/routes/guards/RequireRole.tsx (CONVERTED TO TYPESCRIPT)

import React from 'react';
import { useOutletContext, Navigate, Outlet } from 'react-router-dom';

// Define the type for the component's props
interface RequireRoleProps {
  allowedRoles: string[];
}

// Define the expected shape of the context from the parent layout
interface AppOutletContext {
  userData?: {
    role?: string;
  };
}

const RequireRole: React.FC<RequireRoleProps> = ({ allowedRoles }: any) => {
  // Explicitly type the context to prevent 'any' type
  const outletContext = useOutletContext<AppOutletContext>();
  const userRole = outletContext?.userData?.role;

  if (!userRole) {
    // If role is not available, deny access by default for security.
    return <Navigate to="/" replace />;
  }

  const isAllowed = allowedRoles.includes(userRole);

  // This correctly renders the nested child routes (e.g., FounderPortal) via the Outlet
  return isAllowed ? <Outlet context={outletContext} /> : <Navigate to="/" replace />;
};

export default RequireRole;